// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bC3Tb","signatureBlock":"Footer_signatureBlock__1vNgW","signature":"Footer_signature__2Xhhj"};